import model from 'modules/buildingLevel1/buildingLevel1Model';

const { fields } = model;

export default [
  fields.id,
  fields.name,
  fields.level2,
  fields.createdAt,
  fields.updatedAt
];
